import { CompleteYourLookLook } from "../../../domain/projections/CompleteYourLookLook";
import { CompleteYourLookLookRepository } from "../../../domain/repositories/CompleteYourLookLookRepository";
import { createHttpClients } from "../shared/createHttpClients";
import { CompleteYourLookLookDTO, mapCompleteYouLookLookDTOtoCompleteYourLookLook } from "./responseMapper";

class CompleteYourLookLookRepositoryImpl implements CompleteYourLookLookRepository {
  private static instance: CompleteYourLookLookRepositoryImpl;

  private constructor() {}

  public static getInstance(): CompleteYourLookLookRepositoryImpl {
    if (!CompleteYourLookLookRepositoryImpl.instance) {
      CompleteYourLookLookRepositoryImpl.instance = new CompleteYourLookLookRepositoryImpl();
    }

    return CompleteYourLookLookRepositoryImpl.instance;
  }

  public async get(
    auth: string,
    anchorProductVariantId: string | undefined,
    apiUrl: () => string,
  ): Promise<CompleteYourLookLook[]> {
    try {
      const { httpPost } = createHttpClients(auth, apiUrl);
      const { looks } = await httpPost<{ looks: CompleteYourLookLookDTO[] }>({
        endpoint: `/looks/v2/view-recommendation`,
        body: { anchorProductVariantId },
      });
      return looks.map((look: CompleteYourLookLookDTO) => mapCompleteYouLookLookDTOtoCompleteYourLookLook(look));
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export { CompleteYourLookLookRepositoryImpl };
